export const safeInternalRedirect = (redirect?: string | null) => {
  const hasControlCharacter =
    typeof redirect === 'string' &&
    Array.from(redirect).some((character) => {
      const code = character.charCodeAt(0);
      return code < 32 || code === 127;
    });
  if (
    !redirect ||
    !/^\/(?!\/)/.test(redirect) ||
    redirect.includes('\\') ||
    hasControlCharacter
  ) {
    return undefined;
  }

  try {
    decodeURIComponent(redirect);
    return redirect;
  } catch {
    return undefined;
  }
};
